import FieldSet from '../../FieldSet';
import terminology from 'javascripts/terminology';
import { ReleasesCount } from './ReleasesCount';

export class ReleasesFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [ReleasesCount];
  }

  get title() {
    return terminology('Releases');
  }
}
